var EPlaceholderIconsNames = /* @__PURE__ */ ((EPlaceholderIconsNames2) => {
  EPlaceholderIconsNames2["ATTENTION"] = "Attention";
  EPlaceholderIconsNames2["BOT"] = "Bot";
  EPlaceholderIconsNames2["CALENDAR"] = "Calendar";
  EPlaceholderIconsNames2["CALL"] = "Call";
  EPlaceholderIconsNames2["CAUTION"] = "Caution";
  EPlaceholderIconsNames2["CHANNEL"] = "Channel";
  EPlaceholderIconsNames2["CHAT"] = "Chat";
  EPlaceholderIconsNames2["CLIPBOARD"] = "Clipboard";
  EPlaceholderIconsNames2["COMMENT_COLOR"] = "CommentColor";
  EPlaceholderIconsNames2["COMMENT_MONO"] = "CommentMono";
  EPlaceholderIconsNames2["CONFERENCES"] = "Conferences";
  EPlaceholderIconsNames2["EMPTY"] = "Empty";
  EPlaceholderIconsNames2["ERROR"] = "Error";
  EPlaceholderIconsNames2["EXIT"] = "Exit";
  EPlaceholderIconsNames2["FAVOURITE"] = "Favourite";
  EPlaceholderIconsNames2["FIREWALL"] = "Firewall";
  EPlaceholderIconsNames2["IMAGES"] = "Images";
  EPlaceholderIconsNames2["JOURNAL"] = "Journal";
  EPlaceholderIconsNames2["LOCK"] = "Lock";
  EPlaceholderIconsNames2["LOCK_RED"] = "LockRed";
  EPlaceholderIconsNames2["LOCK_YELLOW"] = "LockYellow";
  EPlaceholderIconsNames2["MAIL"] = "Mail";
  EPlaceholderIconsNames2["MAINTENANCE"] = "Maintenance";
  EPlaceholderIconsNames2["MAN"] = "Man";
  EPlaceholderIconsNames2["NO_DEMONSTRATION"] = "NoDemonstration";
  EPlaceholderIconsNames2["NOT_FOUND"] = "NotFound";
  EPlaceholderIconsNames2["PAUSE"] = "Pause";
  EPlaceholderIconsNames2["PROFILES"] = "Profiles";
  EPlaceholderIconsNames2["QR"] = "Qr";
  EPlaceholderIconsNames2["QUALITY"] = "Quality";
  EPlaceholderIconsNames2["REACTION"] = "Reaction";
  EPlaceholderIconsNames2["SEARCH"] = "Search";
  EPlaceholderIconsNames2["SECURITY"] = "Security";
  EPlaceholderIconsNames2["SEND"] = "Send";
  EPlaceholderIconsNames2["SPEAKER"] = "Speaker";
  EPlaceholderIconsNames2["START"] = "Start";
  EPlaceholderIconsNames2["TIME"] = "Time";
  EPlaceholderIconsNames2["TRANSLATION"] = "Translation";
  EPlaceholderIconsNames2["TV"] = "Tv";
  EPlaceholderIconsNames2["ULTRASOUND"] = "Ultrasound";
  EPlaceholderIconsNames2["UPGRADE"] = "Upgrade";
  EPlaceholderIconsNames2["VIDEO"] = "Video";
  EPlaceholderIconsNames2["WAITING"] = "Waiting";
  EPlaceholderIconsNames2["WAITING_YELLOW"] = "WaitingYellow";
  EPlaceholderIconsNames2["WOMAN"] = "Woman";
  return EPlaceholderIconsNames2;
})(EPlaceholderIconsNames || {});
export {
  EPlaceholderIconsNames
};
